/* eslint-disable no-underscore-dangle */
import axios from 'axios'
import { setAccessToken, setRefreshToken } from '../redux/slices/authSlice'
import { store } from '../redux/store'

declare const VERSION: string

const apiClient = axios.create({
    // Later read this URL from an environment variable
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Accept-Language': 'fa-ir',
        'Platform-Version': `${
            process.env.REACT_APP_PLATFORM_VERSION as string
        }_v${VERSION}`,
    },
})

apiClient.interceptors.request.use(async (config) => {
    const token = localStorage.getItem('dc_accessToken')
    const publicKey = localStorage.getItem('dc_publicKey')
    if (token && config.headers) {
        config.headers.Authorization = token
    }

    if (publicKey && config.headers) {
        config.headers.Public = publicKey
    }

    // Clear empty params
    Object.keys(config.params || {}).forEach((key) => {
        if (
            config.params[key] === '' ||
            config.params[key] === null ||
            config.params[key] === undefined
        ) {
            delete config.params[key]
        }
    })

    return config
})

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalConfig = error.config
        if (error.response) {
            if (error.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true
                // Get Tokens
                const refreshToken = localStorage.getItem('dc_refreshToken')

                try {
                    const newToken = await axios.get(
                        '/microservice/authorization/refresh-token',
                        {
                            baseURL: process.env.REACT_APP_API_URL,
                            headers: {
                                'Accept-Language': 'fa-ir',
                                'Platform-Version': `${
                                    process.env
                                        .REACT_APP_PLATFORM_VERSION as string
                                }_v${VERSION}`,
                                Authorization: refreshToken as string,
                            },
                        }
                    )
                    store.dispatch(
                        setAccessToken(newToken.data.data.access_token)
                    )
                    store.dispatch(
                        setRefreshToken(newToken.data.data.refresh_token)
                    )

                    originalConfig.headers = {
                        ...originalConfig.headers,
                        Authorization: `${newToken.data.data.access_token}`,
                    }
                } catch (er) {
                    if (axios.isAxiosError(er)) {
                        if (er.response?.status === 401) {
                            localStorage.removeItem('dc_accessToken')
                            localStorage.removeItem('dc_refreshToken')
                            window.location.replace('/auth/login')
                        }
                    }
                }

                return axios(originalConfig)
            }
            // Api error
            // Sentry.configureScope((scope) => {
            //     scope.setContext("service error", {
            //         error_response: error.response,
            //     });
            //     // scope.clear();
            // });
        }

        return Promise.reject(error)
    }
)

export default apiClient
